/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Menu: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="menu" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3475 226.6524999999999H226.6950000000002V340H1133.3475V226.6524999999999zM1133.3475 623.3475000000001H510.0000000000001V736.695H1133.3475V623.3475000000001zM1133.3475 1020H226.6950000000002V1133.3475H1133.3475V1020z" : "M906.6780000000002 181.3219999999999H181.3560000000001V272H906.6780000000002V181.3219999999999zM906.6780000000002 498.6780000000001H408.0000000000001V589.356H906.6780000000002V498.6780000000001zM906.6780000000002 816H181.3560000000001V906.678H906.6780000000002V816z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Menu.displayName = `Blueprint5.Icon.Menu`;
export default Menu;
